"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Target = exports.TargetProvider = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const TargetContext = react_1.default.createContext({
    clickHandler: () => { }
});
const TargetProvider = ({ children, clickHandler, targetResolver }) => {
    return (react_1.default.createElement(TargetContext.Provider, { value: { clickHandler, targetResolver } }, children));
};
exports.TargetProvider = TargetProvider;
exports.Target = react_1.default.forwardRef((_a, ref) => {
    var { children, disabled, onClick, sx } = _a, props = __rest(_a, ["children", "disabled", "onClick", "sx"]);
    const { clickHandler, targetResolver } = react_1.default.useContext(TargetContext);
    const hrefResolved = react_1.default.useMemo(() => {
        if ("href" in props) {
            const resolved = targetResolver === null || targetResolver === void 0 ? void 0 : targetResolver(props.href);
            if (typeof resolved === "object" && resolved !== null) {
                return resolved.href;
            }
            return props.href;
        }
        return undefined;
    }, [props, targetResolver]);
    const targetResolved = react_1.default.useMemo(() => {
        if (!targetResolver) {
            if ("target" in props) {
                return props.target;
            }
        }
        else {
            if ("href" in props) {
                const resolved = targetResolver(props.href);
                if (typeof resolved === "string") {
                    return resolved;
                }
                else if (typeof resolved === "object" && resolved !== null) {
                    return resolved.target;
                }
            }
        }
        return undefined;
    }, [props, targetResolver]);
    const cursor = react_1.default.useMemo(() => {
        if (sx === null || sx === void 0 ? void 0 : sx.cursor) {
            return sx === null || sx === void 0 ? void 0 : sx.cursor;
        }
        else if (disabled) {
            return "not-allowed";
        }
        else if ("href" in props ||
            ("type" in props && props.type === "submit") ||
            onClick) {
            return "pointer";
        }
        else {
            return "default";
        }
    }, [disabled, onClick, props, sx === null || sx === void 0 ? void 0 : sx.cursor]);
    const handleClick = react_1.default.useCallback((e) => {
        if (disabled) {
            e.preventDefault();
        }
        else {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            if (!e.defaultPrevented) {
                clickHandler(e);
            }
        }
    }, [clickHandler, disabled, onClick]);
    if (hrefResolved) {
        const anchorProps = __rest(props, []);
        return (react_1.default.createElement(foundations_1.Box, Object.assign({}, anchorProps, { as: "a", "aria-disabled": disabled, href: hrefResolved, onClick: handleClick, sx: Object.assign(Object.assign({}, sx), { cursor }), ref: ref, target: targetResolved }), children));
    }
    else {
        const _b = props, { role = "button" } = _b, buttonProps = __rest(_b, ["role"]);
        return (react_1.default.createElement(foundations_1.Box, Object.assign({}, buttonProps, { as: "button", "aria-disabled": disabled, role: role, sx: Object.assign(Object.assign({}, sx), { cursor }), onClick: handleClick, ref: ref }), children));
    }
});
exports.Target.displayName = "Target";
//# sourceMappingURL=Target.js.map